module.exports = __webpack_public_path__ + "img/flutter_on_the_wind.46a5fd15.jpg";